import CardUserProfile from "@/components/Card/card-user-profile";
import Spinner from "@/components/Spinner";
import { Button, Modal } from "antd";

export type typeCancelInvitation = {
  id: string;
  _version: number | string;
};

interface IModalPendingCoc {
  isOpen: boolean;
  data: any[];
  onCancel: () => void;
  onCancelInvitation: (payload: typeCancelInvitation) => void;
  isLoadingGetCancelUser: boolean;
}

export default function ModalPendingCoc({
  isOpen,
  data = [],
  onCancel,
  onCancelInvitation,
  isLoadingGetCancelUser,
}: IModalPendingCoc) {
  return (
    <Modal open={isOpen} title="List of Invitees" footer={null} onCancel={onCancel}>
      <div className="grid grid-cols-1 gap-4 lg:gap-5 pt-6 relative">
        {data.map((item) => (
          <div key={item?.user?.id} className="flex justify-between items-center">
            <CardUserProfile
              item={item?.user}
              cgPercent={item?.CGPercent}
              variant="horizontal"
              points={item?.user?.points}
              avatarSize="sm"
            />
            <Button
              onClick={() =>
                onCancelInvitation({ id: item?.user?.id, _version: item?.user?._version })
              }
            >
              Cancel Invitation
            </Button>
          </div>
        ))}

        {isLoadingGetCancelUser && (
          <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-0 flex items-center justify-center">
            <Spinner />
          </div>
        )}
      </div>
    </Modal>
  );
}
